import { render, staticRenderFns } from "./treinamento.vue?vue&type=template&id=a10d0188&scoped=true"
import script from "./treinamento.vue?vue&type=script&lang=js"
export * from "./treinamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10d0188",
  null
  
)

export default component.exports